import React from 'react'
import './footer.css'
import Ideum from '../images/ideum-logo.png'
import Insta from '../images/insta.png'
import Link from '../images/linkedin.png'
import Youtube from '../images/youtube.png'
import Facebook from '../images/fb.png'

export default function footer({theme, sparklingTheme, beerTheme}) {

  const highlight = {1: '#F8EBA9', 2: '#860000', 3: '#FFC9C1', 4: '#FFC9C1', 5: '#F8EBA9', 6: '#FBBD14'}

  return (
    <div>
        <div className='accent' style={{
  backgroundColor: 
    theme !== undefined 
      ? highlight[theme] 
      : sparklingTheme !== undefined 
        ? highlight[sparklingTheme] 
        : highlight[beerTheme]
}}
></div>
        <div className='footer'>
            <div className="footer-container">
                <div className='logo-container'>
                    <img className='ideum-logo' src={Ideum}></img>
                    <div className='wine-ex-div'>
                        <p className='wine-experience'>The Wine Experience</p>
                    </div>
                </div>
                <div className='social-div' >
                    <a className='link insta' href='https://www.instagram.com/ideum/?hl=en'>
                        <img src={Insta} className='social-icon' alt='Instagram icon'></img>
                    </a>
                    <a className='link Linkedin' href='https://www.linkedin.com/company/ideum'>
                        <img src={Link} className='social-icon' alt='Linkedin icon'></img>
                    </a>
                    <a className='link youtube' href='https://www.youtube.com/channel/UCh1eDd1edZ8ZKjMfm6FOx2A'>
                        <img src={Youtube} className='social-icon' alt='Youtube icon'></img>
                    </a>
                    <a className='link facebook' href='https://www.facebook.com/ideum/'>
                        <img src={Facebook} className='social-icon' alt='Facebook icon'></img>
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}
